import React from 'react'

const Share = (
  {
    color = '#CBCBCB'
  }
) => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill={color} d="M40.8,45.1c-0.1,0-0.3,0-0.4-0.1l-16.6-8.2c-0.5-0.2-0.7-0.8-0.5-1.3c0.2-0.5,0.8-0.7,1.3-0.5l16.7,8.2
	c0.5,0.2,0.7,0.8,0.5,1.3C41.5,44.9,41.2,45.1,40.8,45.1z M24.2,30.1c-0.4,0-0.7-0.2-0.9-0.6c-0.2-0.5,0-1.1,0.5-1.3L40.4,20
	c0.5-0.2,1.1,0,1.3,0.5c0.2,0.5,0,1.1-0.5,1.3L24.6,30C24.5,30.1,24.3,30.1,24.2,30.1z"/>
      <path fill={color} d="M17.5,41C12.8,41,9,37.2,9,32.5c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5C26,37.2,22.2,41,17.5,41z M17.5,26
	c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5S21.1,26,17.5,26z"/>
      <path fill={color} d="M47.5,26c-4.7,0-8.5-3.8-8.5-8.5S42.8,9,47.5,9s8.5,3.8,8.5,8.5S52.2,26,47.5,26z M47.5,11
	c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5S51.1,11,47.5,11z"/>
      <path fill={color} d="M47.5,56c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5S52.2,56,47.5,56z M47.5,41
	c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5S51.1,41,47.5,41z"/>
    </svg>
  )
}

export default Share
